"use strict";
exports.__esModule = true;
exports.isColorAssignmentItemChanged = exports.isFluidLegendEnabled = exports.dataValueAsFloat = exports.getMinMax = exports.isPointsConfigChanged = exports.isClusteringAllowed = exports.getFormatFromExecutionResponse = exports.calculateAverage = exports.isLocationMissing = exports.isDataOfReasonableSize = exports.getGeoAttributeHeaderItems = void 0;
var tslib_1 = require("tslib");
// (C) 2019-2021 GoodData Corporation
var sdk_ui_1 = require("@gooddata/sdk-ui");
var sdk_model_1 = require("@gooddata/sdk-model");
var isEqual_1 = tslib_1.__importDefault(require("lodash/isEqual"));
var responsive_1 = require("./responsive");
function getGeoAttributeHeaderItems(dv, geoData) {
    var color = geoData.color, size = geoData.size;
    var hasColorMeasure = color !== undefined;
    var hasSizeMeasure = size !== undefined;
    var attrHeaderItemIndex = hasColorMeasure || hasSizeMeasure ? 1 : 0;
    return dv.meta().allHeaders()[attrHeaderItemIndex];
}
exports.getGeoAttributeHeaderItems = getGeoAttributeHeaderItems;
function isDataOfReasonableSize(dv, geoData, limit) {
    var location = geoData.location;
    var attributeHeaderItems = getGeoAttributeHeaderItems(dv, geoData);
    var locationData = location !== undefined ? attributeHeaderItems[location.index] : [];
    return locationData.length <= limit;
}
exports.isDataOfReasonableSize = isDataOfReasonableSize;
function isLocationMissing(buckets) {
    var locationBucket = sdk_model_1.bucketsFind(buckets, sdk_ui_1.BucketNames.LOCATION);
    return !locationBucket || sdk_model_1.bucketIsEmpty(locationBucket);
}
exports.isLocationMissing = isLocationMissing;
function calculateAverage(values) {
    if (values === void 0) { values = []; }
    if (!values.length) {
        return 0;
    }
    return values.reduce(function (a, b) { return a + b; }, 0) / values.length;
}
exports.calculateAverage = calculateAverage;
function getFormatFromExecutionResponse(dv, indexMeasure) {
    var measureDescriptors = dv.meta().measureDescriptors();
    return measureDescriptors[indexMeasure].measureHeaderItem.format;
}
exports.getFormatFromExecutionResponse = getFormatFromExecutionResponse;
// show clusters when there is location attribute only
function isClusteringAllowed(geoData, groupNearbyPoints) {
    if (groupNearbyPoints === void 0) { groupNearbyPoints = true; }
    var color = geoData.color, location = geoData.location, segment = geoData.segment, size = geoData.size;
    return Boolean(groupNearbyPoints && location && !(color || segment || size));
}
exports.isClusteringAllowed = isClusteringAllowed;
function isPointsConfigChanged(prevPointsConfig, pointsConfig) {
    return !isEqual_1["default"](prevPointsConfig, pointsConfig);
}
exports.isPointsConfigChanged = isPointsConfigChanged;
/**
 * Get min/max values in number array and ignore NaN values
 */
function getMinMax(data) {
    return data.reduce(function (result, value) {
        if (!isFinite(value)) {
            return result;
        }
        var min = result.min && isFinite(result.min) ? Math.min(value, result.min) : value;
        var max = result.max && isFinite(result.max) ? Math.max(value, result.max) : value;
        return {
            min: min,
            max: max
        };
    }, {
        min: undefined,
        max: undefined
    });
}
exports.getMinMax = getMinMax;
function dataValueAsFloat(value) {
    if (value === null) {
        return NaN;
    }
    var parsedNumber = typeof value === "string" ? parseFloat(value) : value;
    if (isNaN(parsedNumber)) {
        // eslint-disable-next-line no-console
        console.warn("SDK: utils - stringToFloat: " + value + " is not a number");
    }
    return parsedNumber;
}
exports.dataValueAsFloat = dataValueAsFloat;
function isFluidLegendEnabled(responsive, showFluidLegend) {
    return responsive_1.getResponsiveInfo(responsive) === true && showFluidLegend;
}
exports.isFluidLegendEnabled = isFluidLegendEnabled;
function isColorAssignmentItemChanged(prevColorAssignment, colorAssignment) {
    return !isEqual_1["default"](prevColorAssignment, colorAssignment);
}
exports.isColorAssignmentItemChanged = isColorAssignmentItemChanged;
//# sourceMappingURL=common.js.map